export default "__VITE_ASSET__2523f523__"